import React, { ReactNode } from 'react';
import { Product } from '../../../../types/working-model';

interface ProductWrapperProps {
	item: Product;
	onClick: (item: Product) => void;
	children: ReactNode;
}

export const ProductWrapper = ({ item, onClick, children }: ProductWrapperProps): JSX.Element => {
	// open the product modal
	if (!item.settings?.bypass_modal)
		return (
			<li className='product product-item-clickable' role='button' onClick={item.images.length === 1 ? () => onClick(item) : () => null}>
				{children}
			</li>
		);

	// go straight to the product
	if (item.buy_now_link) {
		const link = item.buy_now_link.startsWith('http') ? item.buy_now_link : `https://${item.buy_now_link}`;

		return (
			<a className='product product-item-link' href={link} target={item.cta_new_tab ? '_blank' : '_self'} rel='noreferrer'>
				{children}
			</a>
		);
	}

	// product is not clickable
	return (
		<li className='product'>
			{children}
		</li>
	);
};